import { useCallback, useState } from 'react';

import { WidgetViewMode, WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

import { OptionValue } from 'components/common/CustomizedStatusSelect/CustomizedStatusSelect.types';

import { DEFAULT_PAGE_VIEW_GRAPH_LINE_OPTIONS, graphLineOptionsInflates } from 'components/widgets/SCurve/Scurve.utils';

import { useScurveStore } from 'store/scurve.store';

const resolveInitialLocalValue = (widgetViewMode: WidgetViewMode, localFilters: any): OptionValue[] => {
    if (WidgetViewModeUtils.isPageView(widgetViewMode) || WidgetViewModeUtils.isReportAddWidget(widgetViewMode)) {
        return DEFAULT_PAGE_VIEW_GRAPH_LINE_OPTIONS;
    }
    // report view or report edit - should get from stored value
    return localFilters?.graphLineOptions
        ? graphLineOptionsInflates(localFilters.graphLineOptions)
        : DEFAULT_PAGE_VIEW_GRAPH_LINE_OPTIONS;
};

export const useGraphLineOptions = (widgetViewMode: WidgetViewMode, localFilters: any) => {
    const isPageView = WidgetViewModeUtils.isPageView(widgetViewMode);
    // Page view: shared global state
    const storeValue = useScurveStore((s) => s.graphLineOptions);
    const storeUpdate = useScurveStore((s) => s.update);
    // Report view: isolated per-widget state
    const [localValue, setLocalValue] = useState<OptionValue[]>(() =>
        resolveInitialLocalValue(widgetViewMode, localFilters),
    );
    const value = isPageView ? storeValue : localValue;
    const setValue = useCallback(
        (options: OptionValue[]) => {
            if (isPageView) {
                storeUpdate({ graphLineOptions: options });
            } else {
                setLocalValue(options);
            }
        },
        [isPageView, storeUpdate],
    );
    return [value, setValue] as const;
};
